export default "__VITE_ASSET__Crpx5l$3__"